import React from 'react';
import ReactDOM from 'react-dom';
import './react-datepicker.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import WebFont from 'webfontloader';
import { isBrowser } from "react-device-detect";

if(isBrowser && window===window.top) window.top.location = '/test.html';

WebFont.load({
  google: {
    families: ['Lato:400,700:latin,latin-ext', 'sans-serif']
  }
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
